import { type Upload, UploadSchema } from '../data/upload';
import {
  type Companion,
  type UploaderConnection,
  UploaderConnectionSchema,
} from '../data/uploader-connection';
import { createMultipleHandler, createSingleHandler } from '../helpers/fetch-wrapper';
import { storesBaseUrl as baseUrl, StoreScopedService } from './base';

export class UploadService extends StoreScopedService {
  getUploadsByStore(storeId: string): Promise<Upload[]> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/uploads`)
      .then(createMultipleHandler(UploadSchema));
  }

  getCompanionConnections(storeId: string): Promise<UploaderConnection[]> {
    return this.fetchWrapper
      .get(`${baseUrl}/${storeId}/companions/connections`)
      .then(createMultipleHandler(UploaderConnectionSchema));
  }

  async getCompanions(storeId: string): Promise<Companion[]> {
    const connections = await this.getCompanionConnections(storeId);

    return connections.filter((c): c is Companion => !!c.uploader);
  }

  triggerUpload(storeId: string): Promise<Upload> {
    return this.fetchWrapper
      .post(`${baseUrl}/${storeId}/uploads/trigger`, {})
      .then(createSingleHandler(UploadSchema));
  }

  generateUploadUrls(
    storeId: string,
    vendorId: string,
    invoices: { filename: string; sha256: string }[]
  ): Promise<{ prefix: string; urls: Record<string, string> }> {
    return this.fetchWrapper
      .post(`${baseUrl}/${storeId}/generate-invoices-upload-urls`, {
        vendor_id: vendorId,
        invoices,
      })
      .then((r) => r.json());
  }
}
